module.exports = __webpack_public_path__ + "static/img/hua11.2d228ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hua11.png
// module id = Ys8g
// module chunks = 22